import store from '../../store/store';
import { action } from 'satcheljs/lib/legacy';
/**
 * Changes the ignoreSubsequentRules value in the inbox rule edit store
 * @param shouldIgnoreSubsequentRules value to set, sets the corresponding value for the inbox rule
 */
export default action('setIgnoreSubsequentRules')(function setIgnoreSubsequentRules(shouldIgnoreSubsequentRules) {
    store.inboxRulesEditState.ignoreSubsequentRules = shouldIgnoreSubsequentRules;
});
//# sourceMappingURL=setIgnoreSubsequentRules.js.map